var chunkMapping = {
	"25": [
		2025
	],
	"283": [
		7283
	],
	"371": [
		5371
	],
	"533": [
		6533
	],
	"961": [
		4961
	]
};
var idToExternalAndNameMapping = {
	"2025": [
		"default",
		"./OnboardingApp",
		1033
	],
	"4961": [
		"default",
		"./PagosApp",
		9505
	],
	"5371": [
		"default",
		"./DenunciaSiniestrosApp",
		5588
	],
	"6533": [
		"default",
		"./CotizadoresApp",
		3419
	],
	"7283": [
		"default",
		"./ConsultaPolizaApp",
		3572
	]
};
var idToRemoteMap = {
	"2025": [
		{
			"externalType": "script",
			"name": "onboarding",
			"externalModuleId": 1033
		}
	],
	"4961": [
		{
			"externalType": "script",
			"name": "pagos",
			"externalModuleId": 9505
		}
	],
	"5371": [
		{
			"externalType": "script",
			"name": "denunciaSiniestros",
			"externalModuleId": 5588
		}
	],
	"6533": [
		{
			"externalType": "script",
			"name": "cotizadores",
			"externalModuleId": 3419
		}
	],
	"7283": [
		{
			"externalType": "script",
			"name": "consultaPoliza",
			"externalModuleId": 3572
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}